import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperclip20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPaperclip20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.263 3.98c-.456.452-.763 1.143-.763 2.096V12.8c0 .872.488 1.955 1.353 2.84.856.876 1.986 1.457 3.147 1.457 1.251 0 2.378-.409 3.182-1.13.795-.714 1.318-1.77 1.318-3.167V5.848H16v6.953c0 1.804-.69 3.272-1.816 4.281-1.115 1.001-2.613 1.515-4.184 1.515-1.66 0-3.156-.821-4.22-1.908C4.727 15.609 4 14.169 4 12.8V6.076c0-1.288.424-2.385 1.208-3.162C5.99 2.14 7.065 1.75 8.25 1.75s2.26.39 3.042 1.164c.784.777 1.208 1.874 1.208 3.162V12.8c0 1.478-1.287 2.297-2.5 2.297-.693 0-1.32-.22-1.782-.641A2.2 2.2 0 0 1 7.5 12.8V5.848H9V12.8c0 .235.087.418.23.548.145.133.393.25.77.25.646 0 1-.388 1-.798V6.076c0-.953-.307-1.644-.763-2.096-.458-.453-1.133-.73-1.987-.73s-1.529.277-1.987.73M8.25 5.097a.75.75 0 0 1 .75.75H7.5a.75.75 0 0 1 .75-.75m7 0a.75.75 0 0 1 .75.75h-1.5a.75.75 0 0 1 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperclip20);
